import React, { useEffect } from 'react';
import Routing from 'Routes';
import InProgress from 'Pages/InProgress';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'App.css';
import { SETTING_CONFIG, STRING_CONFIG } from 'utils';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useDispatch, useSelector } from 'react-redux';
import { hideToast, setOnlineStatus, showToast } from 'store/platform/actions';
import { useAdTray } from 'contexts/AdTrayContext';
import { getSubscriptionValidity } from 'api/platformRequest';
import axios from 'axios';
import { isTokenExpired } from 'helpers';
import { signOut } from 'store/auth/actions';

function App() {
  const dispatch = useDispatch();

  const { setIsPaymentSuccess } = useAdTray();

  const authToken = useSelector((state) => state.auth.token);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      if (navigator.onLine) {
        dispatch(setOnlineStatus(true));

        dispatch(hideToast());
      } else {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtNoInternet, // message
            'error', // type
            6000, // duration
            false, // presistent
            true // closable
          )
        );

        dispatch(setOnlineStatus(false));
      }
    };

    window.addEventListener('online', handleOnlineStatusChange);

    window.addEventListener('offline', handleOnlineStatusChange);

    handleOnlineStatusChange();

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);

      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        const { data } = await getSubscriptionValidity(authToken);
        if (data.success === true) {
          setIsPaymentSuccess(data?.is_valid || false);
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          return;
        }
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      }
    };
    if (authToken) {
      fetchPaymentStatus();
    }
  }, []);

  useEffect(() => {
    if (authToken) {
      let tokenExpired = isTokenExpired(authToken)
      if (tokenExpired) {
        dispatch(
          showToast(
            'Session Expired!',
            'error',
            3000,
            false,
            true
          )
        );
        setTimeout(() => {
          dispatch(signOut());
          window.location.reload();
        }, 3000)
      }
    }
  }, []);


  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      {SETTING_CONFIG.campaign.CP001.isActive ? <InProgress /> : <Routing />}
    </GoogleOAuthProvider>
  );
}

export default App;
